import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { SelectInput } from '../../../../atoms';
import { RootState } from '../../../../redux/root';
import { setPermittingDoc, setPermittingDocErrors } from '../../../../redux/slices/wikiSlice';
import { useGetVocabularyQuery } from '../../../../redux/rtkQuery/apiSlice';

type Props = {
  label: string;
  entity: number;
  name: string;
  value: any;
  onChange: any;
  showValidation?: boolean
};
const Dropdown: FC<Props> = ({ label, entity, name, value, onChange, showValidation = false }) => {
  const { permittingDoc: data, permittingDocErrors: errors } = useSelector((s: RootState) => s.wikiSlice);
  const [items, setItems] = useState<any[]>([]);
  const { data: voca } = useGetVocabularyQuery(entity);
  const dispatch = useDispatch();

  useEffect(() => {
    if (voca) {
      // @ts-ignore
      const _workItems = voca.results.map(item => ({
        label: item.title,
        value: item.id,
      }));
      setItems(_workItems);
    }
  }, [voca]);

  return (
    <Wrapper>
      <Label>
        {label}
        <Required>*</Required>
      </Label>
      <SelectInput
        getOptionValue={(item: any) => item.id || Math.random()}
        getOptionLabel={(item: any) => item.label}
        options={items}
        value={value}
        onChange={onChange}
        error={errors && showValidation && errors[name]}
      />
      {showValidation && errors && errors[name] && <Errors>{errors[name].message}</Errors>}
    </Wrapper>
  );
};

export default Dropdown;

const Wrapper = styled.div`
  width: 100%; ;
`;

const Required = styled.div`
  color: red;
`;

const Label = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 9px;
  margin-left: 10px;
`;

const Errors = styled.div`
  color: red;
  position: relative;
  top: 7px;
  left: 11px;
`;
